import { styled } from '@linaria/react';

import {
	HEIGHT as INPUT_HEIGHT,
	Input,
	type TSize,
} from '~shared/ui/atoms/Input';

const SPACING = {
	M: '4px',
	L: '8px',
};
const LEFT_ICON_SIZE = '24px';
const RIGHT_ICON_SIZE = '34px';
const DEFAULT_PADDING = '10px';

export const Wrapper = styled.div<{ uiSize?: TSize }>`
	position: relative;
	display: flex;
	align-items: center;
`;

export const LeftIconBox = styled.div<{ uiSize?: TSize; disabled?: boolean }>`
	position: absolute;
	z-index: 1;
	left: ${DEFAULT_PADDING};
	display: flex;
	width: ${LEFT_ICON_SIZE};
	height: ${LEFT_ICON_SIZE};
	align-items: center;
	justify-content: center;
	padding: 4px;
	opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
	pointer-events: none;
`;

export const StyledInput = styled(Input)<{
	uiSize?: TSize;
	hasLeftIcon?: boolean;
	hasRightIcon?: boolean;
}>`
	width: 100%;
	flex: 1;
	/* stylelint-disable */
	padding-left: ${({ hasLeftIcon, uiSize }) =>
		hasLeftIcon
			? `calc(${DEFAULT_PADDING} + ${LEFT_ICON_SIZE} + ${
					SPACING[uiSize ?? 'M']
			  })`
			: DEFAULT_PADDING};
	padding-right: ${({ hasRightIcon, uiSize }) =>
		hasRightIcon
			? `calc(${RIGHT_ICON_SIZE} + ${SPACING[uiSize ?? 'M']})`
			: DEFAULT_PADDING};
	/* stylelint-enable */
`;

export const RightIconBox = styled.div<{ uiSize?: TSize; disabled?: boolean }>`
	position: absolute;
	z-index: 1;
	right: 0;
	display: ${({ disabled }) => (disabled ? 'none' : 'flex')};
	width: ${RIGHT_ICON_SIZE};
	height: ${({ uiSize }) => INPUT_HEIGHT[uiSize ?? 'M']};
	align-items: center;
	justify-content: center;
	padding-right: ${DEFAULT_PADDING};

	cursor: pointer;
	transition: transform 0.2s, opacity 0.2s;

	&:hover {
		opacity: 0.5;
	}
`;
